var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6C19.8481 6 21.75 7.88944 21.75 10.2222C21.75 12.555 19.8481 14.4444 17.5 14.4444C15.1519 14.4444 13.25 12.555 13.25 10.2222C13.25 7.88944 15.1519 6 17.5 6ZM21.75 17.1256C21.75 18.2444 21.4525 20.8517 19.4231 23.765L18.5625 18.6667L19.5612 16.6822C18.9025 16.6083 18.2119 16.5556 17.5 16.5556C16.7881 16.5556 16.0975 16.6083 15.4388 16.6822L16.4375 18.6667L15.5769 23.765C13.5475 20.8517 13.25 18.2444 13.25 17.1256C10.7106 17.8644 9 19.1944 9 20.7778V25H26V20.7778C26 19.1944 24.3 17.8644 21.75 17.1256Z",
    fill: "#E49C2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.bcdc9e601f744fa9d8a712d1d3ba8cc5.svg";
export { ForwardRef as ReactComponent };